import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Scroll-reveal wrapper. Fades + slides content in when it enters the viewport.
export function Reveal({ children, className, delay = 0, y = 55, once = true, amount = 0.15, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 1.6, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export const revealProps = (delay = 0, y = 55) => ({
  initial: { opacity: 0, y },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 1.6, ease: EASE, delay },
});
